var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"formSubscriptionLayout"}},[_c('MainLayout',{attrs:{"loading":_vm.isGetSubscriptionLoading,"with-mobile-step-header":true},scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('SubscriptionStepsNavigation')]},proxy:true},{key:"content",fn:function(){return [_c('router-view')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }